const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      position: fixed;
      bottom: 10px;
      right: 10px;
      z-index: 99;
      display: block;
    }

    button {
      width: 40px;
      height: 40px;
      border: none;
      outline: none;
      background-color: #f0f0f0;
      color: white;
      cursor: pointer;
      padding: 4px;
      border-radius: 6px;
      opacity: 0;
      transform: translateY(100px);
      transition: all .5s ease;
      box-shadow: 0 0 2px 2px rgba(0,0,0,0.1);
    }

    button:hover {
      color: white;
      background-color: red;
    }

    svg {
      width: 32px;
      height: 32px;
      display: block;
    }

    path {
      transition: all .2s ease;
      stroke: #323232;
    }

    button:hover path {
      stroke: white;
    }

    button.showBtn {
      opacity: 1;
      transform: translateY(0);
    }
  </style>

  <button type="button" title="Nach oben" aria-label="Nach oben">
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 15L12.2126 9.21261V9.21261C12.0952 9.09519 11.9048 9.09519 11.7874 9.21261V9.21261L6 15" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
`;

class ScrollTopButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    this.button = this.shadowRoot.querySelector('button');
    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll, { passive: true });
    this.button.removeEventListener('click', this.onClick);
  }

  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const isVisible = scrollTop > 200;
    this.button.classList.toggle('showBtn', isVisible);
  }

  onClick() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }
}

if (!customElements.get('scroll-top-button')) {
  customElements.define('scroll-top-button', ScrollTopButton);
}
